import HasToBeLoggedInGuard from 'app/core/guards/HasToBeLoggedInGuard';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { CannotBeLoggedInGuard } from '../../guards/CannotBeLoggedInGuard';
import NoSidebar from '../../layout/NoSidebar';

const RegisterPage = lazy(() => import('../../../main/register-page/RegisterPage'));
const Dashboard = lazy(() => import('../../../main/dashboard/Dashboard'));
const ClaimAccountPage = lazy(() => import('../../../main/claim-account/ClaimAccountPage'));
const ResetPasswordPage = lazy(() => import('../../../main/reset-password/ResetPasswordPage'));
const ForgotPasswordPage = lazy(() => import('../../../main/reset-password/ForgotPasswordPage'));
const NotificationsHome = lazy(() => import('../../../main/common/messaging/NotificationsHome'));
const ViewReportPage = lazy(() => import('../../../main/common/reports/ViewReportPage'));
const TicketsRedirectPage = lazy(() => import('../../../main/common/tickets/TicketsRedirectPage'));
const ResendEmailPage = lazy(() => import('../../../main/resend-email/ResendEmailPage'));
const Login = lazy(() => import('../../../main/auth/Login'));
const LoginAs = lazy(() => import('../../../main/auth/login-as/LoginAs'));
const LoginOauth = lazy(() => import('../../../main/auth/login-oauth/LoginOauth'));
const Logout = lazy(() => import('../../../main/auth/Logout'));
const LoggedOut = lazy(() => import('../../../main/auth/LoggedOut'));
const AccelaStatus = lazy(() => import('../../../main/accela/AccelaStatus'));
const Error404Page = lazy(() => import('../../../main/errors/Error404Page'));
const AccountTypePicker = lazy(() => import('../../../main/agency/onboarding/account-type-picker/AccountTypePicker'));

const commonRoutes: RouteObject[] = [
  {
    path: '/dashboard',
    element: (
      <Suspense fallback={<DataLoader />}>
        <HasToBeLoggedInGuard>
          <Dashboard />
        </HasToBeLoggedInGuard>
      </Suspense>
    ),
  },
  {
    path: '/',
    element: <NoSidebar />,
    errorElement: <Error404Page />,
    children: [
      {
        path: '/register',
        element: (
          <CannotBeLoggedInGuard>
            <RegisterPage />
          </CannotBeLoggedInGuard>
        ),
      },
      {
        path: '/pick-account',
        element: (
          <Suspense fallback={<DataLoader />}>
            <HasToBeLoggedInGuard>
              <AccountTypePicker />
            </HasToBeLoggedInGuard>
          </Suspense>
        ),
      },
      // {
      //   path: '/claim-account',
      //   element: <ClaimAccountPage />,
      // },
      // {
      //   path: '/reset-password',
      //   element: <ResetPasswordPage />,
      // },
      // {
      //   path: '/forgot-password',
      //   element: <ForgotPasswordPage />,
      // },
      // MESSAGES REDIRECTS
      {
        path: '/n/:messageId',
        element: <NotificationsHome />,
      },
      {
        path: '/l/:messageId',
        element: (
          <HasToBeLoggedInGuard>
            <NotificationsHome />
          </HasToBeLoggedInGuard>
        ),
      },
      // REPORTS REDIRECTS
      {
        path: '/r/:reportId',
        element: <ViewReportPage />,
      },
      // TICKETS REDIRECTS
      {
        path: '/t/:ticketId/:section',
        element: (
          <HasToBeLoggedInGuard>
            <TicketsRedirectPage />
          </HasToBeLoggedInGuard>
        ),
      },
      // OTHER
      {
        path: '/resend-email',
        element: (
          <CannotBeLoggedInGuard>
            <ResendEmailPage />
          </CannotBeLoggedInGuard>
        ),
      },
      {
        path: '/auth/login',
        element: (
          <CannotBeLoggedInGuard>
            <Login />
          </CannotBeLoggedInGuard>
        ),
      },
      {
        path: '/auth/login-as/:id',
        element: <LoginAs />,
      },
      {
        path: '/auth/login-oauth',
        element: <LoginOauth />,
      },
      {
        path: '/auth/logout',
        element: <Logout />,
      },
      {
        path: '/auth/logged-out',
        element: <LoggedOut />,
      },
      {
        path: '/accela/status',
        element: <AccelaStatus />,
      },
    ],
  },
  // unauthorized routes
  {
    path: '/auth',
    element: <Navigate to={'/auth/login'} />,
  },

  // main route redirect to auth
  {
    path: '/',
    element: <Navigate to={'/dashboard'} />,
  },
  // {
  //   path: '/home',
  //   element: <Navigate to={'/dashboard'} />,
  // },
  // route not found
  {
    element: <Error404Page />,
  },
];

export default commonRoutes;
